module.exports = __webpack_public_path__ + "img/bidWin.d7f80e9e.png";